import { useRef, useState } from "react";
import { styles } from "../styles/styles";

import Header from "../components/layout/Header";
import Footer from "../components/layout/Footer";
import ScrollToTopButton from "../components/layout/ScrollToTopButton";

import ContactSection from "../components/sections/ContactSection";
import PuppiesSection from "../components/sections/PuppiesSection";

import { welpenWurf } from "../data/kennelData";

export default function AWurfPage({
                                      kennelName,
                                      primaryColor,
                                      secondaryColor,
                                  }) {
    const [activeNavItem, setActiveNavItem] = useState("litter-a");
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const topRef = useRef(null);
    const aWurfRef = useRef(null);
    const contactRef = useRef(null);

    // Kann sowohl scrollen (Refs) als auch routen (string).
    const handleNav = (target, navKey) => {
        if (typeof target === "string") {
            window.location.href = target; // wenn du React Router nutzt: navigate(target)
            return;
        }

        target?.current?.scrollIntoView({ behavior: "smooth" });
        if (navKey) setActiveNavItem(navKey);
        setIsMenuOpen(false);
    };

    // Navigation auf der A-Wurf Page
    const navItems = [
        { key: "home", label: "Home", ref: "/" },
        { key: "litter-a", label: "A-Wurf", ref: aWurfRef },
        { key: "contact", label: "Kontakt", ref: contactRef },
    ];

    return (
        <div style={styles.container} ref={topRef}>
            <Header
                kennelName={kennelName}
                primaryColor={primaryColor}
                secondaryColor={secondaryColor}
                activeNavItem={activeNavItem}
                isMenuOpen={isMenuOpen}
                onToggleMenu={() => setIsMenuOpen((v) => !v)}
                navItems={navItems}
                onNavClick={(refOrRoute, key) => handleNav(refOrRoute, key)}
                styles={styles}
                // contact optional, falls du im Header Tel/Mail nutzen willst:
                // contact={{ phone: "+49 ...", email: "..." }}
            />

            {/* Simple Hero / Intro (optional) */}
            <div
                style={{
                    padding: "70px 20px 25px",
                    textAlign: "center",
                    maxWidth: 1100,
                    margin: "0 auto",
                }}
            >
                <h2 style={{ margin: 0, color: primaryColor, fontFamily: "'Playfair Display', serif" }}>
                    A-Wurf
                </h2>
                <p style={{ margin: "10px 0 0", color: secondaryColor, lineHeight: 1.6 }}>
                    Hier findest du alle Infos, Bilder und Updates rund um unseren A-Wurf.
                </p>
                <button
                    onClick={() => handleNav(contactRef, "contact")}
                    style={{
                        marginTop: 16,
                        padding: "12px 18px",
                        borderRadius: 14,
                        border: "none",
                        cursor: "pointer",
                        background: primaryColor,
                        color: "#fff",
                        fontWeight: 700,
                    }}
                >
                    Jetzt anfragen
                </button>
            </div>

            {/* Inhalt A-Wurf */}
            <div ref={aWurfRef}>
                <PuppiesSection
                    primaryColor={primaryColor}
                    secondaryColor={secondaryColor}
                    welpenWurf={welpenWurf}
                    styles={styles}
                    onPuppyInquiry={() => handleNav(contactRef, "contact")}
                />
            </div>

            {/* Kontakt */}
            <div ref={contactRef}>
                <ContactSection
                    kennelName={kennelName}
                    primaryColor={primaryColor}
                    styles={styles}
                    onSubmit={(data) => console.log("Form submitted:", data)}
                />
            </div>

            <Footer
                kennelName={kennelName}
                primaryColor={primaryColor}
                navItems={navItems}
                onNavClick={(refOrRoute, key) => handleNav(refOrRoute, key)}
                styles={styles}
            />

            <ScrollToTopButton
                primaryColor={primaryColor}
                onClick={() => handleNav(topRef, "litter-a")}
            />
        </div>
    );
}
